/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentBestOfOption
 */
export interface TournamentBestOfOption {
    /**
     * Number of games in series (1, 3, 5, 7)
     * @type {number}
     * @memberof TournamentBestOfOption
     */
    value: number;
    /**
     * Display label (e.g., "Best of 1", "Best of 3")
     * @type {string}
     * @memberof TournamentBestOfOption
     */
    label: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentBestOfOption
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentBestOfOption
     */
    sortOrder: number;
}

/**
 * Check if a given object implements the TournamentBestOfOption interface.
 */
export function instanceOfTournamentBestOfOption(value: object): value is TournamentBestOfOption {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function TournamentBestOfOptionFromJSON(json: any): TournamentBestOfOption {
    return TournamentBestOfOptionFromJSONTyped(json, false);
}

export function TournamentBestOfOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentBestOfOption {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'label': json['label'],
        'enabled': json['enabled'],
        'sortOrder': json['sortOrder'],
    };
}

export function TournamentBestOfOptionToJSON(json: any): TournamentBestOfOption {
    return TournamentBestOfOptionToJSONTyped(json, false);
}

export function TournamentBestOfOptionToJSONTyped(value?: TournamentBestOfOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'label': value['label'],
        'enabled': value['enabled'],
        'sortOrder': value['sortOrder'],
    };
}

